import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={47.617}
      height={47.616}
      viewBox="0 0 47.617 47.616"
      {...props}
    >
      <path
        data-name="Path 9038"
        d="M14.976 12.667l-3.84 3.84-3.844 3.844-2.3-2.3 7.68-7.68z"
        fill="#fcd770"
      />
      <g data-name="Group 461" fill="#b4dd7f">
        <path
          data-name="Path 9039"
          d="M11.136 16.511l5.376 5.376-3.84 3.84-5.376-5.376z"
        />
        <path
          data-name="Path 9040"
          d="M21.882 34.944l3.84-3.84 8.832 8.831-3.84 3.84z"
        />
        <path
          data-name="Path 9041"
          d="M14.976 12.671l4.26 4.263a6.479 6.479 0 01-1.859 4.086l-.868.868-5.373-5.377z"
        />
        <path
          data-name="Path 9042"
          d="M38.401 36.096l-3.84 3.84-8.832-8.832.868-.868a6.478 6.478 0 014.1-1.859v.015z"
        />
      </g>
      <path
        data-name="Path 9043"
        d="M41.473 46.08v.768h-.768l-9.984-3.072 3.84-3.84 3.84-3.84z"
        fill="#dfb28b"
      />
      <path
        data-name="Path 9044"
        d="M12.668 10.367l-7.676 7.676-3.141-3.137a3.708 3.708 0 010-5.238l2.442-2.442a3.708 3.708 0 015.238 0z"
        fill="#e6e9ed"
      />
      <path
        data-name="Path 9045"
        d="M14.976 41.856L13.433 43.4a6.519 6.519 0 01-9.229-9.209L5.76 32.64z"
        fill="#aab2bd"
      />
      <path
        data-name="Path 9046"
        d="M18.433 41.383a1.629 1.629 0 01-2.78 1.152l-.676-.676-9.217-9.22-.676-.676a1.629 1.629 0 012.3-2.3l10.572 10.564a1.628 1.628 0 01.477 1.156z"
        fill="#d3a06c"
      />
      <path
        data-name="Path 9047"
        d="M21.796 39.459a1.629 1.629 0 01-2.3 2.3l-1.54-1.532L7.388 29.659l-1.536-1.536a1.629 1.629 0 012.3-2.3l2.212 2.212 3.456 3.456 2.3 2.3 3.465 3.452z"
        fill="#d3a06c"
      />
      <path
        data-name="Path 9048"
        d="M31.788.82a13.882 13.882 0 00-12.426 11.646 14.189 14.189 0 00-.115 3.264 6.931 6.931 0 01-.008 1.2 6.479 6.479 0 01-1.859 4.086l-.868.868-3.84 3.84-2.3 2.3 3.456 3.456 2.3 2.3 3.456 3.456 2.3-2.3 3.84-3.84.868-.868a6.478 6.478 0 014.1-1.859 6.755 6.755 0 011.183-.008 14.189 14.189 0 003.264-.115A13.826 13.826 0 0031.788.82z"
        fill="#fcd770"
      />
      <path
        data-name="Path 9049"
        d="M39.261 16.803a2.3 2.3 0 11-3.932 1.624v-1.54l.092-.084a2.315 2.315 0 011.628-.676h.58a2.3 2.3 0 011.632.676z"
        fill="#ffeaa7"
      />
      <path
        data-name="Path 9050"
        d="M30.721 9.979v1.352a2.263 2.263 0 01-.207.952h-2.101a2.3 2.3 0 112.3-2.3z"
        fill="#ffeaa7"
      />
      <path
        data-name="Path 9051"
        d="M43.344 4.272A14.592 14.592 0 0018.6 12.354a14.86 14.86 0 00-.161 2.7l-8.362-8.368a4.476 4.476 0 00-6.33 0L1.311 9.122a4.476 4.476 0 000 6.33l10.275 10.275-1.218 1.218L8.7 25.277a2.394 2.394 0 00-3.428 3.344 2.394 2.394 0 00-.73 3.886l.132.132-1.006 1.007a7.285 7.285 0 0010.3 10.3l1-1 .132.132a2.394 2.394 0 003.886-.73 2.375 2.375 0 001.649.664 2.4 2.4 0 001.7-4.092l-1.664-1.672 1.218-1.218 8.425 8.425 10.166 3.127 1.762.034V46.08L39.08 35.688l-6.514-6.514a14.86 14.86 0 002.7-.161 14.592 14.592 0 008.078-24.741zM16.836 20.478l-.323.323-4.29-4.29 2.754-2.754 3.461 3.461a5.752 5.752 0 01-1.602 3.26zM7.3 19.265l-1.222-1.218 6.594-6.594 1.218 1.218zm-5.76-6.978a2.922 2.922 0 01.86-2.079l2.433-2.436a3.011 3.011 0 014.158 0l2.6 2.6-6.599 6.589-2.6-2.6a2.922 2.922 0 01-.856-2.074zm6.846 8.064l2.75-2.753 4.29 4.29-2.754 2.754zm4.5 22.509a5.75 5.75 0 01-8.132-8.129l1.006-1.005 8.13 8.13zm3.918-.621a.858.858 0 01-.609-.252L5.628 31.422a.861.861 0 011.218-1.218L17.413 40.77a.861.861 0 01-.609 1.47zm4.7-1.629a.861.861 0 01-1.47.609L18.5 39.684 7.932 29.117 6.4 27.581a.861.861 0 011.218-1.218l13.635 13.635a.858.858 0 01.252.609zm9.084-27.106a3.082 3.082 0 00.372-.45h3.6v3.482l-18.4 16.2-1.286-1.286zm-.647-1.986h-1.524a1.536 1.536 0 111.536-1.536v1.349a1.5 1.5 0 01-.011.188zm.457 17.66l6.917 6.92-2.754 2.754-7.746-7.746.321-.321a5.754 5.754 0 013.263-1.6zm-4.67 3.011l7.746 7.746-2.754 2.754-7.746-7.746zm14.926 13.84l-8.488-2.611 5.876-5.876zm5.377-30.27a13.049 13.049 0 01-14.086 11.839 7.43 7.43 0 00-5.895 2.1l-6.465 6.465-2.335-2.336 17.314-15.248a3.072 3.072 0 103.069-3.22h-.581a3.111 3.111 0 00-.955.149v-3.989h-4.613c0-.062.005-.124.005-.187V9.983a3.072 3.072 0 10-3.072 3.072h.527L13.787 30.364l-2.333-2.333 6.468-6.468a7.42 7.42 0 002.091-5.892A13.056 13.056 0 0142.258 5.358a13.072 13.072 0 013.773 10.4zM36.1 18.431v-1.2a1.524 1.524 0 01.955-.333h.581a1.536 1.536 0 11-1.536 1.533z"
      />
      <path
        data-name="Path 9052"
        d="M33.025 3.071v1.536a10.044 10.044 0 019.571 7.131l1.472-.438a11.59 11.59 0 00-11.043-8.229z"
      />
      <path
        data-name="Path 9053"
        d="M43.01 14.588h1.536a11.624 11.624 0 00-.117-1.644l-1.52.217a10.174 10.174 0 01.101 1.427z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
